/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { HistoricalBroadcastMsgListDto } from '../../models/historical-broadcast-msg-list-dto';

export interface GetHistoricalBroadcastMessages$Params {
  /**
   * If not provided, all categories will be returned
   */
  category_id?: number;
}

export function getHistoricalBroadcastMessages(
  http: HttpClient,
  rootUrl: string,
  params?: GetHistoricalBroadcastMessages$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<HistoricalBroadcastMsgListDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    getHistoricalBroadcastMessages.PATH,
    'get',
  );
  if (params) {
    rb.query('category_id', params.category_id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HistoricalBroadcastMsgListDto>;
      }),
    );
}

getHistoricalBroadcastMessages.PATH = '/message/historicalMessage';
